import { createSelector } from 'reselect';
import { showPDPPercentRecommendedSelector } from 'selectors/testTarget/offers/showPDPPercentRecommended/showPDPPercentRecommendedSelector';

const showSelector = createSelector(showPDPPercentRecommendedSelector, showPDPPercentRecommended => !!showPDPPercentRecommended.show);

export { showSelector };
